import * as angular from 'angular';
import * as _ from "lodash";
import {IController} from "angular";
import {SiteContextService} from "../../services/site-context.service";

export class PackageTypeMultiSelectComponent implements IController {
  packageIds: any;
  options: any;
  optionsIds: string[];
  ngPlaceholder: any;
  isDisabled: boolean;
  onOpen: Function;
  onClose: Function;
  onChange: Function;

  public searchTerm: string;

  constructor(private $mdSelect, private siteContextService: SiteContextService) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this._setOptions();
    }
  }

  $onChanges(changes) {
    if (changes.optionsIds && !changes.optionsIds.isFirstChange()){
      this._setOptions();
    }
  };


  onSelectAll() {
    this.onChange({packageIds: _.map(this.options, 'id')});
    this.onClose({packageIds: _.map(this.options, 'id')});
    this.$mdSelect.hide();
  }

  onReset() {
    this.onChange({packageIds: []});
    this.onClose({packageIds: []});
    this.$mdSelect.hide();
  }

  onCancel() {
    this.$mdSelect.hide();
  }

  onSelect() {
    this.onChange({packageIds: this.packageIds});
    this.onClose({packageIds: this.packageIds});
    this.$mdSelect.hide();
  }

  close() {
    this.searchTerm = undefined;
    this.onChange({packageIds: this.packageIds});
    this.onClose({packageIds: this.packageIds});
  }

  private _setOptions() {
    const siteItems = this.siteContextService.getSiteInfo().itemSettings;

    this.options = !this.optionsIds ? siteItems :
        _.filter(siteItems, (i) => {
          return _.includes(this.optionsIds, i.id)
        });
  }

}

angular
    .module('bringoz.admin.commons')
    .component('packageTypeMultiSelect', {
      bindings: {
        packageIds: '<',
        options: '<?',
        optionsIds: '<?',
        ngPlaceholder: '@?',
        isDisabled: '<?',
        onOpen: '&',
        onClose: '&',
        onChange: '&'
      },
      template: require('./package-type-multi-select.html').default,
      controller: PackageTypeMultiSelectComponent
    });
